import { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Row';
const columnEnum = ['', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

/**
 * @class NCRow
 * @column 1
 * @compType 1
 * @canAppend true
 * @path LowCodeComponents.NCRow
 * @label 行容器
 *
 */
class NCRow extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
         * @title 区域编码
         * @description 组件标识
         */
        moduleId: PropTypes.string.isRequired,
        /**
       * @title className
       * @description 组件根元素
       */
        className: PropTypes.string
    }
    static getCompMeta = () => {
        return CompMeta;
    }
    componentDidMount() { }
    componentWillUnmount() { }
    render() {
        return (
            <Row  {...this.props} className={`lc-drop-area ${this.props.className}`}>
                {this.props.children}
            </Row>
        )
    }
}
export default NCRow;
